/**
 * AuthContext — Cognito/Amplify v6 Provider
 *
 * Imports Amplify config as a side-effect so it is configured
 * before any child component tries to use Auth APIs.
 */

import React from 'react';
import '@/lib/amplify-config';

export function AuthProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
